module.exports = __webpack_public_path__ + "static/media/sixr_logo.c498cd98.svg";